<script setup lang="ts">

const isOpen = defineModel<boolean>('isOpen', {
  default: false,
});

const props = defineProps<{
  title: string;
  message: string;
}>();

const emit = defineEmits<{
  dismiss: [];
}>();
</script>

<template>
  <CommonAlert :show-cancel="false" v-model:model-value="isOpen" data-test-id="error-modal">
    <template #title>
      <span data-test-id="error-modal-title">{{ props.title }}</span>
    </template>
    <template #content>
      <p class="mt-2" data-test-id="error-modal-message">{{ props.message }}</p>
    </template>
    <template #confirm>
      <div data-test-id="error-modal-dismiss">Dismiss</div>
    </template>
  </CommonAlert>
</template>
